/** Wizard step ids shared by the forms and their deep links (`?step=`, REC1). */
export const FORM_STEP_PARAM = 'step';

export const STUDENT_FORM_STEP = Object.freeze({
  ESSENTIAL: 'essentiel', PLANNING: 'planning', COURSE: 'cours', HISTORY: 'historique', CONTACT: 'contact',
  CONFIRMATION: 'confirmation',
});

export const FAMILY_FORM_STEP = Object.freeze({
  IDENTITY: 'identite', CONTACT: 'coordonnees', RATE: 'tarif', URSSAF: 'urssaf', EXTRAS: 'extras',
  CONFIRMATION: 'confirmation',
});
